<div class="inbox-wrapper {{ isIE ? 'ie' : '' }}">
	<div class="inbox-message-list">
		<div class="row">
			<div class="col-md-12 options justify-content-between">
				<div class="options-wrapper">
					<div class="float-left {{ totalCount === 0 ? 'disabled' : '' }}">
						<mat-checkbox
							[disabled]="totalCount === 0"
							class="pl-15"
							*ngIf="folder === 'inbox'"
							(change)="selectAllMessages($event)"
							><span [translate]="'messaging.mailbox.select-all'">Select All</span></mat-checkbox
						>
						<mat-checkbox
							[disabled]="!refresh && totalCount === 0"
							class="pl-15"
							*ngIf="folder === 'inbox'"
							(change)="filterMessages($event)"
							><span [translate]="'messaging.mailbox.unread'">Unread</span></mat-checkbox
						>
						<!-- <span class="pl-2">Select All</span> -->
					</div>
					<div class="float-right">
						<i class="fas fa-redo-alt clickable" (click)="getMessages()"></i>
						<i
							class="fa fa-trash {{ totalCount === 0 ? 'disabled' : '' }} clickable"
							*ngIf="folder === 'inbox'"
							aria-hidden="true"
							(click)="deleteSelectedMessages()"
							appEheAnalytics
							[data]="analyticsData"></i>
						<span class="ml-3">Sort</span>
						<span
							*ngIf="sortAscending"
							(click)="sortDesc()"
							class="sort-content clickable"
							appEheAnalytics
							[data]="analyticsData">
							<i class="fas fa-caret-up {{ totalCount === 0 ? 'disabled' : '' }}"></i>
						</span>
						<span
							*ngIf="sortDescending"
							(click)="sortAsc()"
							class="sort-content clickable"
							appEheAnalytics
							[data]="analyticsData">
							<i class="fas fa-caret-down {{ totalCount === 0 ? 'disabled' : '' }}"></i>
						</span>
					</div>
				</div>
			</div>
		</div>

		<ul class="mailbox-item {{ folder === 'inbox' ? 'inbox-item' : 'sent-item' }}">
			<li *ngFor="let message of messageArray; let i = index">
				<div class="message col-12">
					<div class="row">
						<div class="col-3 from">
							<mat-checkbox
								[checked]="selectAll"
								value="{{ message }} "
								(change)="selectedMessage($event, message)"
								*ngIf="folder === 'inbox'"></mat-checkbox>
							<span
								class="pl-2 {{ message?.status === 2 ? 'new-message-font' : 'message-subject-body' }}"
								(click)="showDetailedMessage(message?.id, i + 1)"
								>{{ folder === 'inbox' ? message?.from : message?.to }}</span
							>
						</div>
						<div class="col-7 message-content" (click)="showDetailedMessage(message?.id, i + 1)">
							<span class="{{ message?.status === 2 ? 'new-message-font' : 'message-subject-body' }} "
								>{{ message?.subject }}
							</span>
							-
							<span
								class="{{ message?.status === 2 ? 'new-message-font' : 'message-subject-body' }} "
								[innerHtml]="message?.body"></span>
						</div>
						<div class="message-date col-2">{{ getDate(message?.postedOn) }}</div>
					</div>
				</div>
			</li>
			<li *ngIf="messageArray.length === 0">
				<div class="message py-3 d-flex justify-content-center">
					{{ folder === 'inbox' ? 'Inbox is empty' : 'Sentbox is empty' }}
				</div>
			</li>
		</ul>
	</div>
	<mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage" (page)="changePage($event)">
	</mat-paginator>
</div>
